export const isUserConnected = (): boolean => {
  return document.cookie
    .split(";")
    .some((cookie) => cookie.trim().startsWith("user_id_waalaxy="));
};
